module.exports = __webpack_public_path__ + "static/media/instrument.9efd742c.png";